import { Text, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ITagsData, ITags, IKeyFigureGroup } from "src/api/server/extended-search";
import { Strong } from "src/components/base";
import { Button } from "src/components/base/button";
import { IconFilter } from "src/components/icons";
import { Container } from "src/components/layout/container";
import { MobileSearchFilter } from "src/components/pages/search/components/filter-section/mobile-search-filter/mobile-search-filter";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { SearchFilterHeader } from "../search-filter-header";

interface IMobileSearchFilterContainerProps {
    resultCount: number | null;
    isLoading: boolean;
    tagsData: ITagsData;
    popularKeyFiguresGroup: IKeyFigureGroup;
    keyFiguresGroupsWithIsPopularIndication: IKeyFigureGroup[];
    popularTags: ITags;
    onSearchTermClear: () => void;
    onReset: () => void;
    onSearch: (params: ISearchRequestParamsOmitCountry) => void;
    searchTerm?: string | string[];
}

export const MobileSearchFilterContainer = ({
    searchTerm,
    resultCount,
    isLoading,
    tagsData,
    popularKeyFiguresGroup,
    keyFiguresGroupsWithIsPopularIndication,
    popularTags,
    onSearchTermClear,
    onReset,
    onSearch,
}: IMobileSearchFilterContainerProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = useTranslation(["extended-search"]);
    const { formatNumber } = useNumberFormatter();

    const hasResults = resultCount !== null;
    const displayedResultsCount = hasResults ? formatNumber(resultCount) : "-";
    const wikifoliosFound = resultCount === 1 ? t("wikifolio-found") : t("wikifolios-found");

    return (
        <Container bg="gray.50" pt="3" pb="3" display={["block", "none"]}>
            <SearchFilterHeader searchTerm={searchTerm} isMobile handleOnClear={onSearchTermClear} />
            <Text display={["block", "none"]} mb="2" fontSize="sm">
                <Strong fontSize="xl">{displayedResultsCount}</Strong> {wikifoliosFound}
            </Text>
            <Button leftIcon={<IconFilter w={3} h={3} />} onClick={onOpen} w="100%">
                {t("buttons.filter")}
            </Button>
            <MobileSearchFilter
                isOpen={isOpen}
                isLoading={isLoading}
                resultCount={resultCount}
                tagsData={tagsData}
                popularKeyFiguresGroup={popularKeyFiguresGroup}
                keyFiguresGroups={keyFiguresGroupsWithIsPopularIndication}
                popularTags={popularTags}
                onClose={onClose}
                onReset={onReset}
                onSearch={onSearch}
            />
        </Container>
    );
};
